import { addModuleStyles } from '@glu/theming/glu-css-override';

const styles = ({ legacyButtons }) => (legacyButtons ? {
  root: {
    '& .btn': {
      borderRadius: legacyButtons.borderRadius,
      fontFamily: legacyButtons.fontFamily,
      fontSize: legacyButtons.fontSize,
      padding: legacyButtons.padding,
      height: legacyButtons.height,
      '&[aria-busy]:after': {
        content: 'none'
      },

      '&[aria-busy="true"]:before': {
        borderWidth: legacyButtons.spinnerThickness,
        height: legacyButtons.spinnerSize,
        width: legacyButtons.spinnerSize,
        marginTop: -(legacyButtons.spinnerSize / 2)
      }
    },

    '& .btn-sm': {
      borderRadius: legacyButtons.small.borderRadius,
      fontSize: legacyButtons.small.fontSize,
      padding: legacyButtons.small.padding,
      height: legacyButtons.small.height
    },

    '& .btn-xs': {
      borderRadius: legacyButtons.extraSmall.borderRadius,
      fontSize: legacyButtons.extraSmall.fontSize,
      padding: legacyButtons.extraSmall.padding,
      height: legacyButtons.extraSmall.height,

      '&.btn-xs[aria-busy="true"]:before': {
        height: legacyButtons.extraSmall.spinnerSize,
        width: legacyButtons.extraSmall.spinnerSize,
        marginTop: -(legacyButtons.extraSmall.spinnerSize / 2)
      }
    },

    '& .btn-primary': {
      backgroundColor: legacyButtons.primary.backgroundColor,
      borderColor: legacyButtons.primary.borderColor,
      color: legacyButtons.primary.textColor,
      textTransform: legacyButtons.primary.textTransform,
      fontWeight: legacyButtons.primary.fontWeight,

      '&:hover': {
        backgroundColor: legacyButtons.primary.hoverColor
      },

      '&:focus': {
        outline: legacyButtons.primary.outlineReplacement ? 'none' : undefined,
        boxShadow: legacyButtons.primary.outlineReplacement,
        backgroundColor: legacyButtons.primary.focusColor
      }
    },
    '& .btn-secondary': {
      backgroundColor: legacyButtons.secondary.backgroundColor,
      borderColor: legacyButtons.secondary.borderColor,
      color: legacyButtons.secondary.textColor,
      textTransform: legacyButtons.secondary.textTransform,
      fontWeight: legacyButtons.secondary.fontWeight,

      '&:focus, &:active': {
        backgroundColor: legacyButtons.secondary.focusColor,
        borderColor: legacyButtons.secondary.focusBorderColor
      },

      '&:focus': {
        outline: legacyButtons.primary.outlineReplacement ? 'none' : undefined,
        boxShadow: legacyButtons.primary.outlineReplacement
      },

      '&:hover': {
        backgroundColor: legacyButtons.secondary.hoverColor,
        borderColor: legacyButtons.secondary.borderColor
      }
    },
    '& .btn-tertiary': {
      backgroundColor: legacyButtons.tertiary.backgroundColor,
      border: 'none',
      borderRadius: 0,
      textDecoration: legacyButtons.tertiary.textDecoration,
      color: legacyButtons.tertiary.textColor,

      '&:focus, &:active': {
        backgroundColor: legacyButtons.tertiary.focusColor,
        textDecoration: legacyButtons.tertiary.focusTextDecoration,
        outlineColor: legacyButtons.focusColor
      },

      '&:hover': {
        backgroundColor: legacyButtons.tertiary.hoverColor,
        textDecoration: legacyButtons.tertiary.hoverTextDecoration
      }
    }
  }
} : {});

const defaultTheme = ({ legacy, palette }) => (legacy ? null : {
  borderRadius: 40,
  fontFamily: '"Roboto Condensed", Roboto, Helvetica, Arial, sans-serif',
  fontSize: 18,
  padding: '0 25px 1px',
  height: 40,
  spinnerThickness: 2,
  spinnerSize: 25,
  focusColor: palette.focus.normal,
  primary: {
    backgroundColor: palette.primary.normal,
    borderColor: palette.primary.normal,
    focusColor: palette.primary.dark,
    hoverColor: palette.primary.dark,
    textColor: palette.text.light,
    outlineReplacement: `0 0 3pt 2pt ${palette.focus.normal}`,
    textTransform: 'none',
    fontWeight: 'normal'
  },
  secondary: {
    backgroundColor: palette.background,
    borderColor: palette.primary.normal,
    focusColor: palette.highlightBackground,
    focusBorderColor: palette.primary.normal,
    hoverColor: palette.highlightBackground,
    textColor: palette.primary.normal,
    textTransform: 'none'
  },
  tertiary: {
    backgroundColor: 'inherit',
    textDecoration: 'none',
    focusColor: 'inherit',
    focusTextDecoration: 'underline',
    hoverColor: 'inherit',
    hoverTextDecoration: 'underline',
    textColor: palette.primary.normal
  },
  small: {
    fontSize: 16,
    padding: '0 25px 1px',
    height: 30
  },
  extraSmall: {
    fontSize: 14,
    padding: '0 20px',
    height: 22,
    spinnerSize: 16
  }
});

addModuleStyles(styles, 'legacyButtons', defaultTheme);
